// CON QUE ENTRA CADA UNO (2026-09-21: un login corto cambiado no se veía en
// Usuarios).
//
// Y no se actualizaba porque la pantalla de Usuarios NUNCA leyó el login: se
// lo inventaba
// con la primera palabra del nombre —`u.name.split(' ')[0]`—, así que a todos
// los médicos les ponía «dra.» o «dr.», y a enfermería y a recepción les acertaba por
// casualidad, porque su nombre es una sola palabra. Un rótulo que le dice a la
// gente con qué entrar tiene que decir la verdad; «dra.» no vale ni para
// entrar ni para distinguir a varias doctoras.
//
// La regla de verdad vive en el servidor (routers/auth_router._find_users_by_name)
// y es esta, por orden:
//   1. el `username` corto, si se le ha puesto («Laura»);
//   2. si no, el primer nombre IGNORANDO el tratamiento: «Dra. Laura Demo
//      Gil» entra escribiendo «Laura»;
//   3. y el correo entra siempre.
// Aquí se refleja lo mismo. Si un día cambia allí, el rótulo miente: por eso
// el test compara esta lista con la del backend.
//
// Vive en lib/ y no en la pantalla para que se pueda probar sin arrastrar
// React ni el router.
const TRATAMIENTOS = new Set(['dr', 'dra', 'd', 'da', 'sr', 'sra', 'srta', 'prof']);

export function loginDe(u) {
  const corto = String(u?.username || '').trim();
  if (corto) return corto;
  const tokens = String(u?.name || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/\./g, ' ')
    .split(/\s+/)
    .filter(Boolean);
  if (!tokens.length) return '';
  const significativos = tokens.filter((t) => !TRATAMIENTOS.has(t.toLowerCase()));
  return (significativos[0] || tokens[0]).toLowerCase();
}
